module.exports = __webpack_public_path__ + "img/decore-right.da0ab5cd.png";